export default __webpack_public_path__ + "static/media/10.94bb9884.png";